export default __webpack_public_path__ + "static/media/viz.3249b68b.svg";